import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LatestPosts = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    axios.get(`${API}/posts`).then(({ data }) => setPosts(data.slice(0, 3))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;
  return (
    <section className="border-t border-[#D0E2FF]/60 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="flex items-end justify-between mb-8">
          <h2 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-[#0F172A]">
            From the blog
          </h2>
          <Link to="/blog" className="text-sm font-medium text-[#1E40AF] hover:underline flex items-center gap-1">
            All posts <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid sm:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              data-testid={`home-post-${p.slug}`}
              className="rounded-xl border border-[#D0E2FF] bg-white p-6 hover:shadow-md hover:border-[#A6C8FF] transition-all"
            >
              <div className="text-xs text-[#94A3B8] mb-2">{p.publishDate}</div>
              <div className="font-display font-semibold text-[#0F172A] mb-2">{p.title}</div>
              <p className="text-sm text-[#475569] line-clamp-3">{p.metaDescription}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
